import {
    faDatabase,
    faQuestion,
    faBacteria,
    faLocationCrosshairs,
    faHandHoldingDollar,
    faEnvelope, faList
} from "@fortawesome/free-solid-svg-icons";
import facebook from "../../images/brands/facebook.svg";
import google from "../../images/brands/google-ads.svg";
import googleMerchant from "../../images/brands/google-merchant.svg";
import googleAnalytics from "../../images/brands/google-analytics.svg";
import googleSearchConsole from "../../images/brands/google-search-console.svg";
import googleBigQuery from "../../images/brands/google-bigquery.svg";
import bsShop from "../../images/brands/bs-shop.svg";
import shoptet from "../../images/brands/shoptet.svg";
import sklik from "../../images/brands/sklik.svg";
import zbozi from "../../images/brands/zbozi.svg";
import heureka from "../../images/brands/heureka.svg";
import shopify from "../../images/brands/shopify.svg";
import upgates from "../../images/brands/upgates.svg";
import glami from "../../images/brands/glami.svg";
import microsoft from "../../images/brands/microsoft.svg";
import pinterest from "../../images/remixicons/Logos/pinterest-fill.svg";
import {faSquareLetterboxd, faTiktok} from "@fortawesome/free-brands-svg-icons";
import {useTranslation} from "react-i18next";
import {useIsAdministrator} from "../../components/auth/rolesAndPermissions.js";
import {isBrandVisibleToUser} from "./brandVisibility.js";

export function useBrands() {

    let {t} = useTranslation();

    return {
        //
        // === MARKETING CHANNELS
        //
        'Meta': {
            'name': t('brand.name.facebook-ads'),
            'slug': 'meta',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-white',
            'icon': facebook,
            'isAdSystem': true,
            'isERP': false,
            'isLead': false,
      //      'helpArticleId': 204000025235,
        },
        'Google': {
            'name': t('brand.name.google-ads'),
            'slug': 'google',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-white',
            'icon': google,
            'isAdSystem': true,
            'isERP': false,
            'isLead': false,
            //  'helpArticleId': 204000025236,
        },
        'Microsoft': {
            'name': t('brand.name.microsoft'),
            'slug': 'microsoft',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-white',
            'icon': microsoft,
            'isAdSystem': true,
            'isERP': false,
            'isLead': false,
        },
        'Pinterest': {
            'name': 'Pinterest Ads',
            'slug': 'pinterest',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-white',
            'icon': pinterest,
            'isAdSystem': true,
            'isERP': false,
            'isLead': false,
        },
        'TikTok': {
            'name': t('brand.name.tiktok-ads'),
            'slug': 'tiktok',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-black',
            'icon': faTiktok,
            'isAdSystem': true,
            'isERP': false,
            'isLead': false,
        },
        'Criteo': {
            'name': t('brand.name.criteo-ads'),
            'slug': 'criteo',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-black',
            'icon': faList,
            'isAdSystem': true,
            'isERP': false,
            'isLead': false,
        },
        'GoogleMerchant': {
            'name': 'Google Merchant Center',
            'slug': 'google-merchant',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-white',
            'icon': googleMerchant,
            'isGoogleData': true,
            'googleDataType': 'merchant',
        },
        'GoogleAnalytics': {
            'name': 'Google Analytics 4',
            'slug': 'google-analytics',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-white',
            'icon': googleAnalytics,
            'isGoogleData': true,
            'googleDataType': 'analytics',
        },
        'GoogleSearchConsole': {
            'name': 'Google Search Console',
            'slug': 'google-search-console',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-white',
            'icon': googleSearchConsole,
            'isGoogleData': true,
            'googleDataType': 'search-console',
        },
        'GoogleBigQuery': {
            'name': 'Google BigQuery',
            'slug': 'google-bigquery',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-white',
            'icon': googleBigQuery,
            'isGoogleData': true,
            'googleDataType': 'bigquery',
        },
        'Sklik': {
            'name': 'Sklik',
            'slug': 'sklik',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-white',
            'icon': sklik,
            'isAdSystem': true,
            'isERP': false,
            'isLead': false,
        //    'helpArticleId': 204000025241,
        },
        'Zbozi': {
            'name': 'Zboží.cz',
            'slug': 'zbozi',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-white',
            'icon': zbozi,
            'isAdSystem': true,
            'isERP': false,
            'isLead': false,
        },
        'Heureka': {
            'name': 'Heureka',
            'slug': 'heureka',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-white',
            'icon': heureka,
            'isAdSystem': true,
            'isERP': false,
            'isLead': false,
         //   'helpArticleId': 204000015029,
        },
        'Glami': {
            'name': 'GLAMI',
            'slug': 'glami',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-white',
            'icon': glami,
            'isAdSystem': true,
            'isERP': false,
            'isLead': false,
        //    'helpArticleId': 204000025242,
        },
        //
        // === ERP/LEAD SOURCES
        //
        'MySQLLead': {
            'name': t('brand.name.mysql-leads'),
            'aliases': ['MySQL Leads'],
            'slug': 'mysql',
            'bg': 'bg-[#EEEEEE]',
            'text': 'text-[#9999FF]',
            'icon': faDatabase,
            'isAdSystem': false,
            'isERP': false,
            'isLead': true,
        },
        'BsShop': {
            'name': 'BSSHOP',
            'slug': 'bsshop',
            'bg': 'bg-[#1D2123]',
            'text': 'text-[#FFFFFF]',
            'icon': bsShop,
            'isAdSystem': false,
            'isERP': true,
            'isLead': false,
          //  'helpArticleId': 204000025238,
        },
        'Shoptet': {
            'name': 'Shoptet',
            'slug': 'shoptet',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-white',
            'icon': shoptet,
            'isAdSystem': false,
            'isERP': true,
            'isLead': false,
          //  'helpArticleId': 204000025237,
        },
        /*'Shopify': {
            'name': 'Shopify',
            'slug': 'shopify',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-white',
            'icon': shopify,
            'isAdSystem': false,
            'isERP': true,
            'isLead': false,
        },*/
        'Upgates': {
            'name': 'Upgates',
            'slug': 'upgates',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-white',
            'icon': upgates,
            'isAdSystem': false,
            'isERP': true,
            'isLead': false,
        },
        'UpgatesAddon': {
            'name': t('brand.name.upgates-addon'),
            'slug': 'upgates-addon',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-white',
            'icon': upgates,
            'isAdSystem': false,
            'isERP': false,
            'isLead': false,
            'editable': false,
        },
        'ShoptetAddon': {
            'name': t('brand.name.shoptet-addon'),
            'slug': 'shoptet-addon',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-white',
            'icon': shoptet,
            'isAdSystem': false,
            'isERP': false,
            'isLead': false,
            'editable': false,
        },

        //
        // === AFFILIATE/MAILING
        //

        'Affiliate': {
            'name': t('brand.name.affiliate'),
            'slug': 'affiliate',
            'bg': 'bg-[#2D2926]',
            'text': 'text-[#ed6f63]',
            'icon': faHandHoldingDollar,
            'isAdSystem': false,
            'isERP': false,
            'isLead': false,
        },
        'Mailing': {
            'name': t('brand.name.mailing'),
            'slug': 'mailing',
            'bg': 'bg-[#6E6E6D]',
            'text': 'text-[#FAD0C9]',
            'icon': faEnvelope,
            'isAdSystem': false,
            'isERP': false,
            'isLead': false,
        },
        'Other': {
            'name': t('brand.name.other'),
            'slug': 'other',
            'bg': 'bg-[#333333]',
            'text': 'text-[#04ce04]',
            'icon': faHandHoldingDollar,
            'isAdSystem': false,
            'isERP': false,
            'isLead': false,
        },

        //
        // === GENERIC
        //

        'Direct': {
            'name': t('brand.name.direct'),
            'slug': 'direct',
            'bg': 'bg-[#101820]',
            'text': 'text-[#F2AA4C]',
            'icon': faLocationCrosshairs,
            'isAdSystem': false,
            'isERP': false,
            'isLead': false,
        },
        'Organic': {
            'name': t('brand.name.organic'),
            'slug': 'organic',
            'bg': 'bg-[#A07855]',
            'text': 'text-[#D4B996]',
            'icon': faBacteria,
            'isAdSystem': false,
            'isERP': false,
            'isLead': false,
        },

        //
        // === UNKNOWN
        //

        'Unknown': {
            'name': t('brand.name.unknown'),
            'slug': 'unknown',
            'bg': 'bg-[#7b9acc]',
            'text': 'text-[#FCF6F5]',
            'icon': faList,
            'isAdSystem': false,
            'isERP': false,
            'isLead': false,
        },
    };
}

export function findBrand(brands, findBy) {
    // first, try to find by key (a.k.a. integration name)
    for(let key of Object.keys(brands)) {
        if (key === findBy) {
            return brands[key];
        }
    }

    // second, try to find by slug
    for(let brand of Object.values(brands)) {
        if (brand.slug === findBy) {
            return brand;
        }
    }

    // User-facing API payloads use canonical product names while integration
    // discriminators keep their stable technical keys.
    for(let brand of Object.values(brands)) {
        if (brand.name === findBy) {
            return brand;
        }
    }

    // Runtime API display names stay stable even when the visible brand name is translated.
    for(let brand of Object.values(brands)) {
        if (brand.aliases?.includes(findBy)) {
            return brand;
        }
    }

    return null;
}

export function useBrand(findBy) {
    return findBrand(useBrands(), findBy);
}

export function useAdSystemBrands() {
    let brands = useBrands();
    let isAdministrator = useIsAdministrator();

    let brandList = [];

    for(let brand of Object.values(brands)) {
        if (brand?.isAdSystem === true && isBrandVisibleToUser(brand, isAdministrator)) {
            brandList.push(brand);
        }
    }

    return brandList;
}

export function useErpBrands() {
    let brands = useBrands();

    let brandList = [];

    for(let brand of Object.values(brands)) {
        if (brand?.isERP === true) {
            brandList.push(brand);
        }
    }

    return brandList;
}

export function useGoogleDataBrands() {
    let brands = useBrands();
    let isAdministrator = useIsAdministrator();

    return Object.values(brands).filter((brand) => (
        brand?.isGoogleData === true && isBrandVisibleToUser(brand, isAdministrator)
    ));
}

export function useLeadBrands() {
    let brands = useBrands();

    let brandList = [];

    for(let brand of Object.values(brands)) {
        if (brand?.isLead === true) {
            brandList.push(brand);
        }
    }

    return brandList;
}
